export const DropArrowIcon = () => {
  return (
    <svg
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8207 0.935027L9.0007 6.75503L3.1807 0.935027C2.5957 0.350027 1.6507 0.350027 1.0657 0.935027C0.480703 1.52003 0.480703 2.46503 1.0657 3.05003L7.9507 9.93503C8.5357 10.52 9.4807 10.52 10.0657 9.93503L16.9507 3.05003C17.5357 2.46503 17.5357 1.52003 16.9507 0.935027C16.3657 0.365027 15.4057 0.350027 14.8207 0.935027Z"
        fill="#637381"
      />
    </svg>
  );
};

export default DropArrowIcon;
